import { render } from "./servicesAR.vue?vue&type=template&id=de5c1b8e&scoped=true"
import script from "./servicesAR.vue?vue&type=script&lang=js"
export * from "./servicesAR.vue?vue&type=script&lang=js"

import "./servicesAR.vue?vue&type=style&index=0&id=de5c1b8e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de5c1b8e"]])

export default __exports__